import { CDElement } from "./CDElement";

export class CDMediaQuery extends CDElement
{
  private _query:string; 
  
  constructor( mediaQuery:string )
  {
    super( CDElement.CDMediaQueryType );
    this._query = mediaQuery;
  } 

  get query()
  {
    return this._query;
  }

}